<script>
import { defineAsyncComponent } from 'vue';
import {
  CdrContainer,
} from '@rei/cedar';
import analytics from '../../common/analytics';
import GiftcardBulkComponent from '../../components/giftcard-bulk/GiftcardBulkComponent.vue';
import GiftcardFormComponent from '../../components/giftcard-form/GiftcardFormComponent.vue';
import GiftcardDonationComponent from '../../components/giftcard-donation/GiftcardDonationComponent.vue';
import GiftcardFaqComponent from '../../components/giftcard-faq/GiftcardFaqComponent.vue';
import GiftcardHeaderComponent from '../../components/giftcard-header/GiftcardHeaderComponent.vue';
import GiftcardMobileComponent from '../../components/giftcard-mobile/GiftcardMobileComponent.vue';

export default {
  name: 'GiftcardPageComponent',
  components: {
    CdrContainer,
    GiftcardBulkComponent,
    GiftcardDonationComponent,
    GiftcardFaqComponent,
    GiftcardFormComponent,
    GiftcardHeaderComponent,
    GiftcardMobileComponent,
    GiftcardPreviewComponent: defineAsyncComponent(() => import('../../components/giftcard-preview/GiftcardPreviewComponent.vue')),
  },
  props: {
    giftCards: {
      type: Object,
      required: true,
    },
    giftCardLandingPageContent: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    abAkamaiTestData: {
      type: Object,
      default: () => ({}),
    },
    preFillValue: {
      type: String,
      default: '0.00',
    },
  },
  data() {
    return {
      previewData: {
        opened: false,
        giftCard: {
          id: '',
          srcImg: '',
          altImg: '',
          selected: '',
        },
        to: '',
        from: '',
        amount: null,
        recepientEmail: '',
        confirmEmail: '',
        message: '',
        deliveryDate: '',
      },
      toastData: {
        opened: false,
        alertType: 'success',
        text: 'example',
      },
      headerContent: {
        title: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['page-heading'].text,
        description: this.$props.giftCardLandingPageContent.componentModels['primary-message'].model.text.body.text,
        question: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['redeem-heading'].text,
        ctaBalance: {
          name: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.actions['cta-balance'].text,
          url: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.actions['cta-balance'].target,
        },
        ctaHowTo: {
          name: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.actions['cta-redeem'].text,
          url: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.actions['cta-redeem'].target,
        },
      },
      bulkContent: {
        title: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['bulk-heading'].text,
        description: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['bulk-body'].text,
        ctaBulk: {
          name: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.actions['cta-bulk'].text,
          urlBulk: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.actions['cta-bulk'].target,
        },
      },
      faqContent: {
        title: this.$props.giftCardLandingPageContent.componentModels['frequently-asked-questions'].title,
        faqData: this.$props.giftCardLandingPageContent.componentModels['frequently-asked-questions']
          .questionsAndAnswers.map((faq, index) => ({
            id: (index + 1).toString(),
            question: faq.question,
            answer: faq.answer,
            opened: false,
          })),
      },
      donationContent: {
        disclaimer: this.$props.giftCardLandingPageContent.componentModels['primary-message'].model.text.disclaimer.text,
      },
      mobileContent: {
        title: this.$props.giftCardLandingPageContent.componentModels['mobile-app'].model.text.heading.text,
        description: this.$props.giftCardLandingPageContent.componentModels['mobile-app'].model.text.body.text,
        appstore: {
          url: 'https://apps.apple.com/app/apple-store/id404849387?pt=452174&ct=REIGiftCardPage&mt=8',
          srcImg: 'https://www.rei.com/satchel/media/img/badges/apple-store.png',
        },
        playstore: {
          url: 'https://play.google.com/store/apps/details?id=com.ubermind.rei&referrer=utm_source%3Dreiweb%26utm_medium%3Dweb%26utm_content%3Dreigiftcardpage%26utm_campaign%3DREIGiftCardPage"',
          srcImg: 'https://www.rei.com/satchel/media/img/badges/google-play.png',
        },
      },
      formContent: {
        tabsData: [
          {
            id: 'digital',
            deliveryType: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-type-3'].text,
            deliveryDescription: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-description-3'].text,
            ariaLabel: 'digital-cards',
            dataUi: 'email',
          },
          {
            id: 'physical',
            deliveryType: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-type-4'].text,
            deliveryDescription: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-description-4'].text,
            ariaLabel: 'physical-cards',
            dataUi: 'mail',
          },
        ],
        cmsContent: {
          deliveryType1: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-type-1'].text,
          deliveryType2: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-type-2'].text,
          deliveryType3: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-type-3'].text,
          deliveryType4: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-type-4'].text,
          deliveryDescription1: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-description-1'].text,
          deliveryDescription2: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-description-2'].text,
          deliveryDescription3: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-description-3'].text,
          deliveryDescription4: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['delivery-description-4'].text,
          hipcampDescription: this.$props.giftCardLandingPageContent.componentModels['gift-card-information'].model.text['hip-camp'].text,
          membershipDescription: this.$props.giftCardLandingPageContent.componentModels['gift-card-information'].model.text.membership.text,
          serviceCartFailMessage: this.$props.giftCardLandingPageContent.componentModels['page-content'].model.text['service-cart-fail-message'].text,
        },
        preFillValue: this.$props.preFillValue,
        cards: {
          emailCards: this.$props.giftCards.emailCards
            .map((card) => ({ ...card, selected: false })),
          mailCards: this.$props.giftCards.mailCards
            .map((card) => ({ ...card, selected: false })),
        },
        errors: this.$props.errors,
      },
      analyticData: {
        siteId: 'rei',
        templateType: 'product details',
        productStyles: '999049',
        pageDescription: 'giftcard',
        targetExperienceName: this.$props?.abAkamaiTestData?.ruleName || null,
      },
    };
  },
  mounted() {
    analytics.view({
      pageName: `${this.analyticData.siteId}:${this.analyticData.templateType}:gift card_${this.analyticData.productStyles}`,
      pageDescription: this.analyticData.pageDescription,
      templateType: this.analyticData.templateType,
      siteId: this.analyticData.siteId,
      productStyles: this.analyticData.productStyles,
    });
    this.setAnalyticsLink();
  },
  methods: {
    onPreview(formData) {
      this.previewData.opened = true;
      this.previewData = { ...this.previewData, ...formData };
    },
    onClosePreview(opened) {
      this.previewData.opened = opened;
    },
    setAnalyticsLink() {
      const links = document.querySelectorAll('[data-ui-analytic="link"] a', '[data-ui-analytic="link"] p a');
      links.forEach((a) => a.addEventListener('click', () => {
        analytics.click({ linkName: `${this.analyticData.siteId}:${this.analyticData.pageDescription}_${a.innerText}` });
      }));
    },
  },
};
</script>
<template>
  <cdr-container
    data-ui="page-content"
    class="giftcard-page"
    modifier="fluid"
    style="position: relative"
  >
    <giftcard-header-component
      v-bind="{...headerContent, ...analyticData}"
    />
    <giftcard-form-component
      v-bind="{...formContent, ...analyticData}"
      @openModal="onPreview"
    />
    <giftcard-bulk-component v-bind="{...bulkContent, ...analyticData}" />
    <section class="giftcard-page__faq">
      <giftcard-faq-component v-bind="{...faqContent, ...analyticData}" />
    </section>
    <giftcard-donation-component v-bind="donationContent" />
    <giftcard-mobile-component v-bind="{...mobileContent, ...analyticData}" />
    <giftcard-preview-component
      v-bind="previewData"
      @onCloseModal="onClosePreview"
    />
  </cdr-container>
</template>
